export const roundToDigit = (value, digits = 3) => {
  if (value) {
    const power = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * power) / power;
  }
  return value;
};
